import React from 'react';

export const props = {
  pending: () => {},
  resolve: () => {},
};


const Context = React.createContext(props);

export default Context;

export const withSubmitForm = Compoment => props => {
  return <Context.Consumer>
    {(context) => <Compoment {...props} {...context} />}
  </Context.Consumer>
}